import React from 'react';
import { DoorStickerTemplate } from '../../../../../services/exports/Constants';
import DoorStickerOneForm from './DoorStickerOneForm';
import DoorStickerTwoForm from './DoorStickerTwoForm';

export default function DoorStickerForm({ template, ...rest }) {
  const FormComponent =
    {
      [DoorStickerTemplate.One]: DoorStickerOneForm,
      [DoorStickerTemplate.Two]: DoorStickerTwoForm,
    }[template] ?? null;

  return <FormComponent {...rest} />;
}
